import * as types from '../../action-types';
import {updatePersonalData as initialState } from "../../initialState";

const updatePersonalData = (state=initialState, action) => {
  switch (action.type) {
    case types.UPDATE_PERSONAL_DATA_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPDATE_PERSONAL_DATA_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPDATE_PERSONAL_DATA_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPDATE_PERSONAL_DATA_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updatePersonalData;
